/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React, { useState } from "react";
import { Table, Icon, Grid } from "semantic-ui-react";
import styles from "../MyAccount.module.css";
import { getPlanInfo } from "../../Authenticator/utils";

interface PlanUpdatesProps {
  data: any;
}

const PlanUpdates: React.FC<PlanUpdatesProps> = ({ data }) => {
  const [sorting, setSorting] = useState<any>({
    sortBy: "name",
    reverse: false,
  });

  const sortOrgs = (valueA: any, valueB: any) => {
    let sortValueA, sortValueB;

    switch (sorting.sortBy) {
      case "created":
        sortValueA = valueA.created;
        sortValueB = valueB.created;
        break;

      case "updated":
        sortValueA = valueA.updated;
        sortValueB = valueB.updated;
        break;

      case "prevPlan":
        sortValueA = valueA.oldPlan;
        sortValueB = valueB.oldPlan;
        break;

      case "plan":
        sortValueA = valueA.newPlan;
        sortValueB = valueB.newPlan;
        break;

      default:
        sortValueA = valueA.name ? valueA.name.toLocaleLowerCase() : null;
        sortValueB = valueB.name ? valueB.name.toLocaleLowerCase() : null;
    }

    if (!sortValueA) {
      sortValueA = "";
    }
    if (!sortValueB) {
      sortValueB = "";
    }

    if (sortValueA < sortValueB) {
      return sorting.reverse ? 1 : -1;
    } else if (sortValueA > sortValueB) {
      return sorting.reverse ? -1 : 1;
    }
    return 0;
  };

  const setOrgSorting = (sortBy: string) => {
    setSorting({
      sortBy: sortBy,
      reverse: sortBy === sorting.sortBy ? !sorting.reverse : false,
    });
  };

  const getSortIndicator = (columnName: string) => {
    if (sorting.sortBy === columnName) {
      return (
        <Icon
          name={sorting.reverse ? "triangle down" : "triangle up"}
          style={{ marginLeft: "3px" }}
        />
      );
    }
    return null;
  };

  const planUpdateRow = (planUpdate: any, idx: number) => {
    return (
      <Table.Row key={idx}>
        <Table.Cell>
          {planUpdate.created &&
            new Date(planUpdate.created).toLocaleDateString(navigator.language)}
        </Table.Cell>
        <Table.Cell>
          {planUpdate.updated &&
            new Date(planUpdate.updated).toLocaleDateString(navigator.language)}
        </Table.Cell>

        <Table.Cell>{planUpdate.name}</Table.Cell>

        <Table.Cell>{getPlanInfo(planUpdate.oldPlan).name}</Table.Cell>

        <Table.Cell>{getPlanInfo(planUpdate.newPlan).name}</Table.Cell>
      </Table.Row>
    );
  };

  if (data && data.length > 0) {
    const sortedOrgs = data.sort((orgA: any, orgB: any) =>
      sortOrgs(orgA, orgB)
    );

    return (
      <Table sortable celled compact="very" className={styles.usersTable}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              onClick={() => {
                setOrgSorting("created");
              }}
            >
              Created
              {getSortIndicator("created")}
            </Table.HeaderCell>

            <Table.HeaderCell
              onClick={() => {
                setOrgSorting("updated");
              }}
            >
              Updated
              {getSortIndicator("updated")}
            </Table.HeaderCell>

            <Table.HeaderCell
              onClick={() => {
                setOrgSorting("name");
              }}
            >
              Company Name
              {getSortIndicator("name")}
            </Table.HeaderCell>

            <Table.HeaderCell
              onClick={() => {
                setOrgSorting("prevPlan");
              }}
            >
              Previous Plan
              {getSortIndicator("prevPlan")}
            </Table.HeaderCell>

            <Table.HeaderCell
              onClick={() => {
                setOrgSorting("plan");
              }}
            >
              Upgraded to Plan
              {getSortIndicator("plan")}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {sortedOrgs.map((org: any, idx: number) => planUpdateRow(org, idx))}
        </Table.Body>
      </Table>
    );
  }

  return (
    <Grid>
      <Grid.Column textAlign="center">
        <div className={styles.myAccountNoUsersLabel}>
          {(data && "No data.") || ""}
        </div>
      </Grid.Column>
    </Grid>
  );
};

export default PlanUpdates;
